import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getDiscussion = id => {
  return dispatch => {
    dispatch({ type: "GET_DISCUSSION_LOADING" });
    api
      .discussionGet(id)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFailed());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetDiscussionErrorAlertTitle",
          "Virhe keskustelun lukemisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_DISCUSSION_SUCCEEDED",
  payload: { discussion: data },
});

const operationFailed = () => ({
  type: "GET_DISCUSSION_FAIL"
});
